import React, { Fragment, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as actions from '../variantsActions';
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb';
import { Button } from 'merchant-portal-components';
import VariantList from './components/VariantList';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Icon } from 'merchant-portal-components';
import ReactGA from 'react-ga';
import { InfoIcon } from '../../InfoIcon';
import PaginationControl from '../../../../components/Pagination/PaginationControl';

const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  padding: 37px 0;
`;
const TextSearch = styled.div``;
const TopDiv = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-gap: 20px;
  margin: 0 37px 37px 37px;
`;
const StyledNmbrSpanInactive = styled.span`
  display: block;
  margin-top: 21%;
`;
const FilterButton = styled.div`
  display: inline-flex;
`;
const StyledTab = styled.div`
  display: flex;
  z-index: 55;
`;
const StyledSpanCD = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  background-color: #2440ae;
  color: white;
  padding-left: ${(props) => (props.isSD == true ? '5px' : '3.2px')};
  padding-right: ${(props) => (props.isSD == true ? '5px' : '3.2px')};
  padding-top: ${(props) => (props.isSD == true ? '2px' : '3.2px')};
  padding-bottom: ${(props) => (props.isSD == true ? '2px' : '3.2px')};
  font-size: 13.5px;
`;

const StyledNmbrSpan = styled.span`
  display: block;
  margin-top: 20%;
`;
const PaginationWrapper = styled.div`
  padding: 20px 45px;
  border-top: 1px solid lightgray;
`;
const TxtContr = styled.div`
  margin-top: 6px;
  font-size: 18px;
  margin-right: 6px;
  color: #6f6f76;
`;
const StyledTabBtn = styled.button`
  z-index: 5;
  width: 160px;
  cursor: pointer;
  background-color: ${(props) =>
    props.isActive == false ? 'lightblue' : '#2440ae'};
  color: ${(props) => (props.isActive == false ? '#000' : '#fff')};
  background-color: ${(props) =>
    props.isActive == false ? '#fff' : '#E6EBFF'};
  color: ${(props) => (props.isActive == false ? '#DCDCDC' : '#2440ae')};
  font-weight: ${(props) => (props.isActive == false ? '' : '')};
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
`;
const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 40px;
  margin-bottom: 20px;
`;

const FilterComponent = ({
  selectedFilter,
  setSelectedFilter,
  allVariants,
}) => {
  return (
    <StyledTab>
      <StyledTabBtn
        isActive={selectedFilter == 'active'}
        onClick={() => {
          setSelectedFilter('active');
        }}
      >
        <FilterButton>
          <TxtContr>Active</TxtContr> &nbsp;{' '}
          <StyledSpanCD
            isSD={
              allVariants.filter((ech) => ech.is_active == true).length < 10
            }
          >
            <StyledNmbrSpan>
              {allVariants.filter((ech) => ech.is_active == true).length}
            </StyledNmbrSpan>
          </StyledSpanCD>
        </FilterButton>
      </StyledTabBtn>
      <StyledTabBtn
        isActive={selectedFilter == 'inactive'}
        onClick={() => {
          setSelectedFilter('inactive');
        }}
      >
        <FilterButton>
          <TxtContr>Inactive</TxtContr> &nbsp;{' '}
          <StyledSpanCD
            isSD={
              !(
                allVariants.filter((ech) => ech.is_active == false).length >= 10
              )
            }
          >
            <StyledNmbrSpanInactive>
              {allVariants.filter((ech) => ech.is_active == false).length}
            </StyledNmbrSpanInactive>
          </StyledSpanCD>
        </FilterButton>
      </StyledTabBtn>
      <InfoIcon />
    </StyledTab>
  );
};
const VariantListPage = ({
  allVariants,
  requestParams,
  isGetVariantRequest,
  changeComponentType,
  toggleIsActive,
  isVariantAvailable,
  setEditVariant,
  variantIsSaving,
  getVariants,
  searchString,
  setSearchString,
  isSearching,
}) => {
  const [selectedFilter, setSelectedFilter] = useState('active');
  const handleSearch = (e) => {
    const searchString = e.target.value.toLowerCase();
    setSearchString(searchString);
  };
  const handleClearSearch = () => {
    setSearchString('');
  };
  useEffect(() => {
    ReactGA.pageview(window.location.pathname, undefined, 'Variant List');
  }, []);
  const variantDisplayList = useMemo(() => {
    if (!allVariants) return [];
    switch (selectedFilter) {
      case 'active':
        return allVariants?.filter((each) => each.is_active == true);
      case 'inactive':
        return allVariants?.filter((each) => each.is_active == false);
      default:
        return allVariants;
    }
  }, [allVariants, selectedFilter]);
  return (
    <Fragment>
      <BreadCrumb />
      <Wrapper>
        <TopDiv>
          <TextSearch>
            <TextField
              type='text'
              style={{ width: '100%' }}
              variant='outlined'
              value={searchString}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <Icon className='fal fa-search' />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='start'>
                    <Icon
                      className='fas fa-times-circle'
                      style={{ color: '#193053' }}
                      onClick={handleClearSearch}
                    />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
              placeholder='Search variants'
            />
          </TextSearch>
          <Button
            style={{ width: '100%' }}
            onClick={() => changeComponentType('create')}
          >
            Create Variant
          </Button>
        </TopDiv>
        <FilterWrapper>
          <FilterComponent
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            allVariants={allVariants}
          />
          <PaginationControl
            response={{
              ...allVariants,
              page: requestParams.page_number,
              page_size: requestParams.page_size,
              count: allVariants.length,
            }}
            requestParams={requestParams}
            updateAction={getVariants}
            type='variants'
          />
        </FilterWrapper>
        <VariantList
          isSearching={isSearching}
          variantIsSaving={variantIsSaving}
          allVariants={variantDisplayList}
          requestParams={requestParams}
          isGetVariantRequest={isGetVariantRequest}
          toggleIsActive={toggleIsActive}
          setEditVariant={setEditVariant}
          isVariantAvailable={isVariantAvailable}
          searchString={searchString}
          getVariants={getVariants}
          selectedFilter={selectedFilter}
        />
        <PaginationWrapper>
          <PaginationControl
            response={{
              ...allVariants,
              page: requestParams.page_number,
              page_size: requestParams.page_size,
              count: allVariants.length,
            }}
            requestParams={requestParams}
            updateAction={getVariants}
            type='variants'
          />
        </PaginationWrapper>
      </Wrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  allVariants: state.variantsReducer.allVariants,
  requestParams: state.variantsReducer.requestParams,
  isGetVariantRequest: state.variantsReducer.isGetVariantRequest,
  isVariantAvailable: state.variantsReducer.isVariantAvailable,
  variantIsSaving: state.variantsReducer.variantIsSaving,
});
export default connect(mapStateToProps, actions)(VariantListPage);
